import { render } from "./_integration.vue?vue&type=template&id=34382867&lang=pug"
import script from "./_integration.vue?vue&type=script&lang=js"
export * from "./_integration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__